import React from "react";
import { useSelector } from "react-redux";
import loadingGif from "../assets/loadingimage.gif";

const LoadingOverlay = () => {
  const isLoading = useSelector((state) => state.loading.isLoading);
  if (!isLoading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.0)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <img
        src={loadingGif}
        alt="Loading..."
        style={{ width: 80, height: 80 }}
      />
    </div>
  );
};

export default LoadingOverlay;
